import { Component, Signal, inject, ChangeDetectionStrategy } from '@angular/core'
import { SettingsLanguageComponent } from '../settings-language/settings-language.component'
import { StateService } from '../../../services/state.service'
import { SettingsTreatmentPlaceComponent } from '../settings-treatment-place/settings-treatment-place.component'
import { SettingsTargetGroupComponent } from '../settings-target-group/settings-target-group.component'
import { TranslatePipe } from '@ngx-translate/core'
import { UpperCasePipe } from '@angular/common'
import {
  IonButtons,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonMenuButton,
  IonContent,
  IonItem,
  IonList,
  IonLabel,
  IonNavLink,
} from '@ionic/angular'

@Component({
  selector: 'app-settings-home',
  templateUrl: './settings-home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    UpperCasePipe,
    TranslatePipe,
    IonButtons,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonMenuButton,
    IonContent,
    IonItem,
    IonList,
    IonLabel,
    IonNavLink,
  ],
})
export class SettingsHomeComponent {
  private stateService = inject(StateService)

  readonly currentLanguage: Signal<string | undefined>
  readonly currentTreatmentPlace: Signal<string | undefined>
  readonly targetGroup: Signal<'pre-existing' | 'gestational' | undefined>

  constructor() {
    const stateService = this.stateService

    this.currentLanguage = stateService.currentLanguage
    this.currentTreatmentPlace = stateService.currentTreatmentPlace
    this.targetGroup = stateService.targetGroup
  }

  selectLanguagePage = SettingsLanguageComponent
  selectTreatmentPlacePage = SettingsTreatmentPlaceComponent
  selectTargetGroupPage = SettingsTargetGroupComponent
}
